function parseColorFamilies(container) {
  const dataEl = container.querySelector('.color-family-data');
  if (!dataEl) return [];
  try {
    return JSON.parse(dataEl.textContent);
  } catch (e) {
    console.warn('color-family-filter: invalid JSON', e);
    return [];
  }
}

function buildColorMap(container) {
  const colorMap = {};
  container.querySelectorAll('.color-individual-cb').forEach((checkbox) => {
    colorMap[checkbox.dataset.color.trim()] = checkbox;
  });
  return colorMap;
}

function findMatches(family, colorMap) {
  return (family.colors || [])
    .map((c) => colorMap[c.trim()])
    .filter(Boolean);
}

function getSwatchStyle(hex) {
  const lower = (hex || '#cccccc').toLowerCase();
  const isMulti = lower === 'multi' || lower === 'multicolor';
  const bg = isMulti ? 'linear-gradient(135deg,#f00,#ff0,#0f0,#00f,#f0f)' : hex;
  const border = (lower === '#ffffff' || lower === '#f7f7f7') ? 'border:1px solid #ccc;' : '';
  return `background:${bg};${border}`;
}

function createFamilyButton(family, matches) {
  const isActive = matches.some((cb) => cb.checked);

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'color-family-btn' + (isActive ? ' is-active' : '');
  btn.title = family.name;
  btn.setAttribute('aria-label', family.name);
  btn.setAttribute('aria-pressed', String(isActive));

  btn.innerHTML =
    `<span class="color-family-swatch" style="${getSwatchStyle(family.hex)}"></span>` +
    `<span class="color-family-label">${family.name}</span>`;

  btn.addEventListener('click', () => {
    const newState = !matches.some((cb) => cb.checked);
    matches.forEach((cb) => {
      cb.checked = newState;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    });
    btn.classList.toggle('is-active', newState);
    btn.setAttribute('aria-pressed', String(newState));
  });

  return btn;
}

function buildUI(container) {
  const familyUI = container.querySelector('.color-family-ui');
  if (!familyUI) return;

  const families = parseColorFamilies(container);
  const colorMap = buildColorMap(container);
  if (!families.length || !Object.keys(colorMap).length) return;

  familyUI.innerHTML = '';

  families.forEach((family) => {
    const matches = findMatches(family, colorMap);
    if (!matches.length) return;
    familyUI.appendChild(createFamilyButton(family, matches));
  });
}

function initAll() {
  document.querySelectorAll('[data-color-family-filter]').forEach(buildUI);
}

new MutationObserver((mutations) => {
  const needsInit = mutations.some((m) =>
    Array.from(m.addedNodes).some(
      (node) =>
        node.nodeType === 1 &&
        ((node.matches?.('[data-color-family-filter]')) ||
          (node.querySelector?.('[data-color-family-filter]')))
    )
  );
  if (needsInit) initAll();
}).observe(document.body, { childList: true, subtree: true });

initAll();
